import { getDownloadSelectors, getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const accountDetailDataSelector = getSelectors({
  getRootPath: selectorsConfig.accountDetailDataSelector.getRootPath,
})

export const accountDetailDownloadSelector = getDownloadSelectors({
  getRootPath: selectorsConfig.accountDetailDownloadSelector.getRootPath,
})
